<template>
    <div class="search-dropdown-container">
        <b-input-group class="search-bar">
            <b-input-group-prepend is-text class="left-search-icon">
                <i class="fas fa-search search-icon"></i>
            </b-input-group-prepend>
            <b-form-input type="text" class="search-input" v-model="query" :placeholder="placeholder" @input="onInput"
                @focus="openDropdown" />
            <!-- <b-input-group-append is-text class="right-search-icon" @click="toggleFilterMenu">
                <i class="fas fa-filter filter-icon"></i>
                <div class="filter-container" style="position: relative;">
                    <FilterMenu :isOpen="showFilterMenu" @close="closeFilterMenu" />
                </div>
            </b-input-group-append> -->
            <transition name="fade-slide">
                <div v-if="isOpen" class="menu-dropdown" ref="menuDropdown">
                    <div class="sticky-header">
                        <button class="close-btn" @click="closeDropdown">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                    <!-- <div v-if="isLoading" class="loading-indicator">Laddar...</div> -->
                    <div v-if="searchResults.length > 0" class="results-container">
                        <SearchResult :isLoading="isLoading" :events="searchResults"
                            @fetch-more-events="handleFetchMoreEvents" />
                    </div>
                    <div v-else class="no-results">{{ searchResultText }}</div>
                </div>
            </transition>
        </b-input-group>
    </div>
</template>

<script>
// import { toRaw } from "vue";
import AxiosInstance from "../../api/axios";
// import FilterMenu from "./FilterMenu.vue";
import SearchResult from "./SearchResult1.vue";
import debounce from 'lodash/debounce';

export default {
    components: {
        // FilterMenu,
        SearchResult
    },
    props: {
        placeholder: {
            type: String,
            default: "Sök evenemang...",
        }
    },
    data() {
        return {
            isOpen: false,
            showFilterMenu: false,
            query: "",
            searchResults: [],
            initResult: [],
            isLoading: false,
            isSearching: false,
            isSearchRecentClicked: false,
            pageNumber: 0,
            searchResultText: "Söker..."
        };
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleOutsideClick);
    },
    created() {
        this.debouncedSearch = debounce(this.handleSearch.bind(this), 500);
    },
    methods: {
        onInput() {
            this.pageNumber = 0;
            this.searchResults = [];
            if (!this.query) {
                this.isOpen = false;
                return;
            }

            if (this.query.length < 3) {
                return;
            }
            this.debouncedSearch();
        },
        handleOutsideClick(event) {
            if (this.isSearchRecentClicked) {
                return;
            }

            if (
                this.isOpen &&
                this.$refs.menuDropdown &&
                !this.$refs.menuDropdown.contains(event.target)
            ) {
                this.isOpen = false;
                this.query = null;
                document.removeEventListener('click', this.handleOutsideClick);
            }
        },
        openDropdown() {
            this.isSearchRecentClicked = true;

            setTimeout(() => {
                this.isSearchRecentClicked = false;
            }, 1000);

            document.addEventListener('click', this.handleOutsideClick);
        },
        closeDropdown() {
            this.isOpen = false;
            this.query = null;
            this.isSearchRecentClicked = false;
        },
        toggleFilterMenu() {
            this.showFilterMenu = !this.showFilterMenu;
        },
        closeFilterMenu() {
            this.showFilterMenu = false;
        },
        async handleFetchMoreEvents() {
            await this.handleSearch();
        },
        async handleSearch() {
            if (this.isSearching || this.isLoading) {
                return;
            }
            this.$gtag.event("Search", {
                'event_category': "Event",
                'event_label': "",
                'value': this.query
            });
            this.$gtag.pageview({ page_path: 'Searching' });

            this.searchResultText = "Söker...";

            this.isOpen = true;
            this.isSearching = true;
            this.isLoading = true;

            try {
                const response = await AxiosInstance.get("searchs/" + encodeURIComponent(this.query) + "?PageSize=10&PageNumber=" + this.pageNumber);
                this.searchResults.push(...response.data.events.items);

                this.pageNumber++;

                if (this.query != "" && this.searchResults.length == 0) {
                    this.searchResultText = "Hittade inga events";
                }

            } catch (error) {
                console.error("Error fetching search results:", error);
            } finally {
                this.isSearching = false;
                this.isLoading = false;
            }
        },
        selectResult(item) {
            this.$emit("select", item);
            this.isOpen = false; // Close dropdown after selection
            this.query = null;
        },
    },
};
</script>

<style scoped>
/* Ensure Input Field Doesn't Shrink Too Much */
.search-input {
    min-width: 0;
}

.sticky-header {
    height: 50px;
    position: sticky;
    top: 0;
    z-index: 10;
    /* Ensure it's above the content */
    /* background-color: #15244d; */
    background-color: #141313;
    /* Optional: add background color for better visibility */
    padding: 0px;
}

.close-btn {
    background: none;
    border: none;
    color: #fff;
    font-size: 18px;
    cursor: pointer;
    position: absolute;
    right: 0px;
    top: 10px;
}

.search-dropdown-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
    margin-left: 8%;
}

/* .search-bar-container {
    flex-grow: 1;
    margin-right: 10px;
    margin-left: 10%;
    display: flex;
    justify-content: space-between;
} */

.menu-dropdown {
    background-color: rgba(0, 0, 0, 1) !important;
}

.search-input,
.menu-dropdown {
    /* width: 100%; */
    max-width: 900px;
    box-sizing: border-box;
}

.search-icon {
    color: white;
}

.search-bar {
    /* max-width: 900px !important; */
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: rgba(0, 0, 0, 0.8);
    border-radius: 4px;
}

.search-input {
    flex-grow: 1;
    border: 1px solid rgba(0, 0, 0, 0.8);
    height: 40px;
    color: white !important;
    padding: 0 10px;
    background-color: rgba(0, 0, 0, 0.8);
}

.search-input:focus {
    outline: none;
    box-shadow: none;
    border-color: transparent;
}

.form-control:focus {
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
}

.search-bar .b-input-group-prepend,
.search-bar .b-input-group-append {
    margin: 0;
}

.search-input::placeholder {
    color: white !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.left-search-icon,
.right-search-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.8);
    padding: 0 10px;
    border: 1px solid rgba(0, 0, 0, 0.8);
    height: 40px;
    width: 40px;
    cursor: pointer;
}

.filter-container {
    position: relative;
}

.menu-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: #141313 !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    z-index: 10;
    max-height: 700px;
    overflow-y: auto;
    border-radius: 4px;
    padding: 20px;
    padding-top: 0px;
    margin-top: 5px;
    width: 100% !important;
}

.loading-indicator {
    text-align: center;
    padding: 10px;
    font-size: 14px;
    color: #999;
}

.results-container {
    display: flex;
    flex-direction: column;
}

.result-item {
    display: flex;
    padding: 10px;
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;
    align-items: center;
    transition: background-color 0.2s;
}

.result-item:hover {
    background-color: #f9f9f9;
}

.result-item img {
    width: 50px;
    height: 50px;
    border-radius: 4px;
    margin-right: 10px;
}

.result-details h4 {
    margin: 0;
    font-size: 14px;
    font-weight: bold;
}

.result-details p {
    margin: 0;
    font-size: 12px;
    color: #666;
}

.no-results {
    text-align: center;
    padding: 10px;
    color: white;
    font-size: 12px;
    font-weight: 600;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
    transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}

/* Scrollbar width and track background for WebKit browsers */
::-webkit-scrollbar {
    width: 8px;
    /* Set the scrollbar width */
}

::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.3);
    /* Background color of the scrollbar track */
}

::-webkit-scrollbar-thumb {
    background-color: #141313;
    /* Color of the scrollbar handle */
    border-radius: 4px;
    /* Rounded corners */
    border: 2px solid #141313;
    /* Padding around the handle */
}

::-webkit-scrollbar-thumb:hover {
    background-color: #141313;
    /* Color when hovered */
}

/* Scrollbar styling for Firefox */
* {
    scrollbar-width: thin;
    /* Thin scrollbar */
    scrollbar-color: #141313 #141313;
    /* Handle color and track background */
}

@media (min-width: 1400px) {
    .search-dropdown-container {
        /* width: 60em; */
    }
}

@media (max-width: 1200px) {
    .search-dropdown-container {
        /* width: 50em !important; */
    }
}

@media (max-width: 1100px) {
    .search-dropdown-container {
        /* width: 40em !important; */
    }
}

@media (max-width: 940px) {
    .search-dropdown-container {
        /* width: 35em !important; */
    }
}

@media (max-width: 830px) {
    .search-dropdown-container {
        /* width: 30em !important; */
    }

    .button-container {
        justify-content: center;
        flex-wrap: wrap;
    }
}

@media (max-width: 790px) {
    .search-dropdown-container {
        width: 20em !important;
        margin-left: 0%;
    }

    .button-container {
        justify-content: center;
        flex-wrap: wrap;
    }
}

@media (max-width: 600px) {
    .left-search-icon {
        width: 30px;
        /* Reduce icon size */
    }
}
</style>
